export const WEBSITE_URL = process.env.NEXT_PUBLIC_WEBSITE_URL || 'https://solvapay.com'

const LEGAL_BASE_URL = process.env.NEXT_PUBLIC_LEGAL_BASE_URL || 'https://solvapay.com'
export const LEGAL_TERMS_URL = `${LEGAL_BASE_URL}/legal/terms`
export const LEGAL_PRIVACY_URL = `${LEGAL_BASE_URL}/legal/privacy`
export const LEGAL_COOKIES_URL = `${LEGAL_BASE_URL}/legal/cookies`
